import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { usuarioListComponent } from './usuarios-list/usuario-list.component';
import { usuarioCreateComponent } from './usuarios-create/usuarios-create.component';





const routes: Routes = [

    { path: '', component: usuarioListComponent },
    { path: 'edit/:id', component: usuarioCreateComponent },
    { path: 'crear', component: usuarioCreateComponent }, 
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppUsuarioRoutingModule {}
